module.exports = __webpack_public_path__ + "static/media/cookedleafymeat.ea52c182.webp";